export interface PostQuoteProps {
  quote: string | null
  author: string | null
}

export default function PostQuote({ quote, author }: PostQuoteProps) {
  if (!quote) return null

  return (
    <div className="mb-10 h-auto overflow-hidden rounded-lg bg-light-beige px-6 py-8">
      <div className="md:border-l-[3px] md:border-black md:py-1 md:pl-6">
        <div className="text-xl md:text-2xl">“{quote}”</div>
        {author ? (
          <div className="mt-4 text-dark-gray">
            <span className="text-black">― </span>
            {author}
          </div>
        ) : null}
      </div>
    </div>
  )
}
